export default __webpack_public_path__ + "static/O0132-fc5d5b2e95be1b4e49080d4d363f54b9.png";